// src/components/FirebaseIdentitySync.js — renders nothing. Keeps the member's
// Firestore identity in step with their Clerk login (adr-firestore-identity.md
// step a2). Mounted once in the real App (not DemoApp).
//
// Role is read from Clerk publicMetadata (server-controlled) and normalised to
// the three values the custom token carries. The server re-derives the role
// itself when minting, so this value is only used to notice a CHANGE (e.g. a
// friend grant) and re-mint; it can't grant anything.

import { useEffect } from 'react';
import { useUser, useAuth } from '@clerk/clerk-react';
import { setClerkIdentity } from '../services/firebaseAuth';
import { getCachedSiteContent } from '../services/firebase';

function roleClaim(role) {
    if (role === 'admin') return 'admin';
    if (role === 'friend') return 'friend';
    return 'member';
}

export default function FirebaseIdentitySync() {
    const { isLoaded, isSignedIn, user } = useUser();
    const { getToken } = useAuth();
    const userId = user?.id || null;
    const role = roleClaim(user?.publicMetadata?.role);

    useEffect(() => {
        if (!isLoaded) return;
        // Kill switch: siteConfig.firebaseAuthEnabled === false ⇒ exactly the
        // pre-a2 behaviour (no hand-over, writes never wait).
        const enabled = (getCachedSiteContent() || {}).firebaseAuthEnabled !== false;
        setClerkIdentity(isSignedIn && userId ? { userId, role, getToken } : null, { enabled });
    }, [isLoaded, isSignedIn, userId, role, getToken]);

    return null;
}
